import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { GetDashboardTotalRevenueChartData } from "../../../utils/api";
import { message } from "antd";
import { constructParams } from "./constructParams";
import Loader from "../../shared/Loader";
import { convertToViewableAmount } from "../../../utils/helper";

const options = {
  responsive: true,
  scales: {
    y: {
      border: { dash: [4, 4] },
      ticks: {
        display: true,
        callback: (value) => `£${value.toFixed(2)}`,
        // stepSize: 100,
      },
    },
    x: {
      grid: {
        display: false,
      },
      ticks: {
        display: true,
      },
    },
  },
  plugins: {
    legend: {
      display: false,
    },
    title: {
      display: false,
    },
    tooltip: {
      callbacks: {
        label: (tooltipItem) =>
          convertToViewableAmount(tooltipItem.formattedValue),
      },
    },
  },
};

const TotalRevenueChart = ({ selectedOption, startDate, endDate }) => {
  const [totalRevenueData, setTotalRevenueData] = useState({
    period: [],
    totalRevenue: [],
  });

  const [loading, setLoading] = useState(true);

  const fetch = async (params) => {
    try {
      setLoading(true);
      const queryParams = new URLSearchParams(params).toString();
      const response = await GetDashboardTotalRevenueChartData(queryParams);
      const mappedData = response?.items?.map((item) => ({
        date: item?.date,
        totalRevenue: item?.totalRevenue,
      }));
      setTotalRevenueData((prevState) => ({
        ...prevState,
        period: mappedData?.map((item) => item.date),
        totalRevenue: mappedData?.map((item) => item.totalRevenue),
      }));
      setLoading(false);
    } catch (error) {
      setLoading(false);
      message.error(error || "Unknown error occured. Please try again later.");
    }
  };

  useEffect(() => {
    const params = constructParams(selectedOption, startDate, endDate);
    fetch(params);
  }, [selectedOption, startDate, endDate]);

  const totalRevenue = {
    labels: totalRevenueData?.period,
    datasets: [
      {
        label: "Revenue",
        data: totalRevenueData?.totalRevenue,
        backgroundColor: "#059774",
        borderColor: "transparent",
        borderWidth: 2,
        barThickness: 13,
      },
    ],
  };
  return (
    <div className="box-shadow sm:w-6/12 w-full rounded-xl flex-1 p-4">
      <div className="flex items-center justify-between text-xs">
        <h2 className="text-sm font-semibold text-[#272727]">Total Revenue</h2>
      </div>
      <div className="w-full flex items-center justify-center mt-1">
        {loading ? (
          <Loader height="h-[40vh]" />
        ) : (
          <Bar data={totalRevenue} options={options} />
        )}
      </div>
    </div>
  );
};

export default TotalRevenueChart;
